// Pure streak-free daily blessing. No Pixi, no DOM. Wall-clock day is injected by game.ts.
// (Wildergrove_Research.md §10 rank 1: no streak reset, banks if skipped, pure upside.)

export type BlessingId = 'double_embers' | 'satchel_safe' | 'dungeon_gold';
export const BLESSING_ROTATION: { id: BlessingId; label: string }[] = [
  { id: 'double_embers', label: 'Double embers today' },
  { id: 'satchel_safe', label: '+1 satchel item survives death today' },
  { id: 'dungeon_gold', label: '+50% dungeon gold today' },
];
export const BLESSING_BANK_CAP = 3;

export function dayUTC(ms: number): number {
  return Math.floor(ms / 86_400_000);
}

/** Today's rotating blessing (deterministic by calendar day). */
export function todaysBlessing(ms: number): { id: BlessingId; label: string } {
  return BLESSING_ROTATION[dayUTC(ms) % BLESSING_ROTATION.length];
}

/** Accrue banked blessings for days elapsed since last accrual (capped, never resets/punishes). */
export function accrueBlessing(bl: { lastAccrualDayUTC: number; banked: number }, ms: number): void {
  const d = dayUTC(ms);
  const gained = d - bl.lastAccrualDayUTC;
  if (gained > 0) {
    bl.banked = Math.min(BLESSING_BANK_CAP, bl.banked + gained);
    bl.lastAccrualDayUTC = d;
  }
}
